// Semantic pill tones for the CRM redesign.
// Source of truth: design_handoff_crm_redesign/README.md §Семантические тона
// + mockup_2.dc.html renderVals(). Values are CSS vars from src/index.css
// (:root = exact light hex, .dark = dark palette) so pills follow the theme.

export type Tone = "green" | "amber" | "gray" | "red" | "blue" | "violet";

export interface ToneSpec {
  /** pill background */
  bg: string;
  /** pill text/foreground */
  fg: string;
  /** leading dot color (null when the tone has no dot) */
  dot: string | null;
}

export const TONES: Record<Tone, ToneSpec> = {
  green: { bg: "var(--tone-green-bg)", fg: "var(--tone-green-fg)", dot: "var(--tone-green-dot)" },
  amber: { bg: "var(--tone-amber-bg)", fg: "var(--tone-amber-fg)", dot: "var(--tone-amber-dot)" },
  gray: { bg: "var(--tone-gray-bg)", fg: "var(--tone-gray-fg)", dot: "var(--tone-gray-dot)" },
  red: { bg: "var(--tone-red-bg)", fg: "var(--tone-red-fg)", dot: "var(--tone-red-dot)" },
  blue: { bg: "var(--tone-blue-bg)", fg: "var(--tone-blue-fg)", dot: "var(--tone-blue-dot)" },
  violet: { bg: "var(--tone-violet-bg)", fg: "var(--tone-violet-fg)", dot: null },
};

/** Готовность → тон (с dot). */
export const READINESS_TONE: Record<string, Tone> = {
  Да: "green",
  Нет: "gray",
  "На проверке": "amber",
};

/** Лояльность → тон (без dot). */
export const LOYALTY_TONE: Record<string, Tone> = {
  Лоялен: "green",
  Нейтрален: "gray",
  Колеблется: "amber",
  Противник: "red",
};
